export default "__VITE_ASSET__b9e3ab71__"